import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { userWithPermissionSchema } from '../types';

export const createGetUserQuery = () =>
	createAuthQuery({
		params: declareParams<number>(),
		request: {
			method: 'GET',
			url: (id) => `/user/${id}`,
		},
		response: {
			contract: zodContract(userWithPermissionSchema),
		},
	});

export const getUserQuery = createGetUserQuery();
